import { getFeatures } from "@/utils/utils"

export default {
    methods : {
        checkGameEnable() {
            const features = getFeatures();
            const gameItems = features.filter((item: any) => item.isGame === true && item.enabled === true);
            return gameItems
        }
    }
}
